/***************** SLIDER ******************/
function makeSliders() {
  document.querySelectorAll('.bd-slider').forEach((slider) => {
     
    const arrows =  slider.dataset.arrows == 'true' ? true : false;
    const dots = slider.dataset.dots == 'true' ? true : false;
    const adaptiveHeight = slider.dataset.adaptiveHeight == 'true'
      ? true
      : false;
      const navfor = slider.dataset.navFor ? document.querySelector(`${slider.dataset.navFor}`) : false;
      const freeScroll = slider.dataset.freeScroll == 'true'
      ? true
      : false; 
    const wrapAround = slider.dataset.wrapAround == 'true'
      ? true
      : false;
    const initialIndex = slider.dataset.initialIndex
      ? parseInt(slider.dataset.initialIndex)
      : 0;
    const cellAlign = slider.dataset.cellAlign ? slider.dataset.cellAlign : 'left';
    const autoPlay = slider.dataset.autoplay ? slider.dataset.autoplay : 0;
    const watchCSS = slider.dataset.watchCss == 'true' ? true : false;
   
      console.log(initialIndex, 'InitialIndex');
  
    const flkty = new Flickity(slider, { 
      prevNextButtons: arrows,
      pageDots: dots,
      draggable: true,
      adaptiveHeight: adaptiveHeight,
      asNavFor: navfor,
      freeScroll: freeScroll,
      wrapAround: wrapAround,
      initialIndex: initialIndex,
      autoPlay: autoPlay,
      cellAlign: cellAlign,
      watchCSS: watchCSS,
      groupCells: true,
      contain: true,
      percentPosition: false,
      imagesLoaded: true,
      arrowShape: d="m66.935 10a3.6364 3.6364 0 0 0-2.571 1.0653l-38.935 38.935 38.935 38.935a3.6364 3.6364 0 0 0 5.1421 0 3.6364 3.6364 0 0 0 0-5.1421l-33.793-33.793 33.793-33.793a3.6364 3.6364 0 0 0 0-5.1421 3.6364 3.6364 0 0 0-2.571-1.0653z",
      on: {
        ready: function () {
          // console.log('ready slider', dots);
          const event = new Event('sliderMade');
          slider.dispatchEvent(event);
        },
      },
    });
  
    // FOR CUSTOM PAGINATION
  
    function customPagination(slider, flkty) {
      //console.log(slider, 'for custom Pag');
    //console.log('ready custom pag', slider.dataset.customPag);
      if (slider.dataset.customPag) {
    
        const target = slider.dataset.customPag;
        //console.log('custom slider pagination target', target);
        const pagContainer = document.querySelector(
          `[data-pag-target="${target}"]`
        );
  
        if(pagContainer) {
        pagContainer.addEventListener('click', (e) => {
          //console.log(e.target);
          if (e.target.classList.contains('next-arrow')) {
            flkty.next();
          }
          if (e.target.classList.contains('prev-arrow')) {
            flkty.previous();
          }
        });
     
        function updateStatus(slider, flkty, pagContainer) {
          const cellNumber = flkty.selectedIndex + 1;
          // console.log(cellNumber, 'CELL NUMBER');
  
          if (cellNumber == 1) {
            pagContainer.querySelector('.prev-arrow').classList.add('disabled');
          } else {
            pagContainer
              .querySelector('.prev-arrow')
              .classList.remove('disabled');
          }
          if (cellNumber == flkty.selectedIndex) {
            pagContainer.querySelector('.next-arrow').classList.add('disabled');
          } else {
            pagContainer
              .querySelector('.next-arrow')
              .classList.remove('disabled');
          }
        }
  
        function updatePagNames(slider, flkty, pagContainer, index) { 
          console.log(pagContainer);
          const size = flkty.cells.length;
          // console.log('Slide Length', size);
          const currentSlide = slider.querySelector(
            `[data-index="${flkty.selectedIndex}"]`
          );
          let nextSlide = slider.querySelector(
            `[data-index="${flkty.selectedIndex + 1}"]`
          );
          let prevSlide = slider.querySelector(
            `[data-index="${flkty.selectedIndex - 1}"]`
          );
          // console.log(prevSlide, nextSlide);
          // console.log(index, 'IS INDEX')
          if (index < size - 1) {
            // console.log('currentIndex', index);
          } else {
            nextSlide = slider.querySelector(`[data-index="0"]`);
            
            // console.log('Next Slide is First Slide', nextSlide);
          }
          if (index > 0) {
            // console.log('we have previous slides');
          } else {
            prevSlide = slider.querySelector(`[data-index="${size - 1}"]`);
            // console.log('Previous Slide is Last Slide', prevSlide);
          }
  
          // console.log('nextSlide', nextSlide);
          // console.log('prevSlide', prevSlide);
  
          const nextTitle = nextSlide ? nextSlide.dataset.title : ''; 
          const prevTitle = prevSlide ? prevSlide.dataset.title : '';
  
          // console.log('nextTitle', nextTitle);
          // console.log('prevTitle', prevTitle);
          pagContainer.querySelector('[data-next-text]').innerHTML = nextTitle;
          pagContainer.querySelector('[data-prev-text]').innerHTML = prevTitle;
       
        }
   
  
        flkty.on('change', function(index) {
          updatePagNames(slider, flkty, pagContainer, index);
          // updateStatus(); 
        }); 
        updatePagNames(slider, flkty, pagContainer, 0); 
        updateStatus(slider, flkty, pagContainer); 
      }
    }
    }
    // END CUSTOM PAGINATION
  
    customPagination(slider, flkty);
    //console.log( flkty);
  }); // END EACH
  }
 
    makeSliders();